import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from "../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit";
import ObjectsPage from "../../../../_metronic/layout/components/basePage/pages/ObjectsPage";
import { FilterObjectsUIProvider } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import {
  rowFormatter,
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  detailColumns,
  placColumns,
  prepareFilterTreeSelect,
  placeFilterFields,
  filterInitialValues,
  setParentData,
  setDetailData,
} from "./ManagementAuditFormReportUtils";

const ManagementPlaceAuditFormReportPage = () => {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.placeAuditFormReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find((q) => q.url == "/placeManageReport")) {
    const temp = menuList.find((q) => q.url == "/placeManageReport");
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute
            path="/placeManageReport"
            render={(props) => (
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/placeManageReport"
                api="api/AuditFormResult"
                getFunctionName="GetPlacesFormResultReport"
                exportfuncName="GetExcelPlacesFormResultReport2"
                currentState={currentState}
                columns={columns}
                detailColumns={detailColumns}
                setParentData={setParentData}
                setDetailData={setDetailData}
                prepareFilter={prepareFilterTreeSelect}
                filterFields={placeFilterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}

                haveStimulsoftReport={true}
                mrtUrl="/reports/FormResultReports.mrt"
                jsonFileName="GetFormResultReport"
              />
            )}
          />
        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  );
};

export default ManagementPlaceAuditFormReportPage;
